import type { Route } from "@b2bportal/air-disruption-api";
import {
  airRebookApi,
  ShopRequestMethodEnum,
  type ShopResponseResultSuccess,
} from "@b2bportal/air-rebook-api";
import { type Flights, ResponseEnum } from "@b2bportal/air-shopping-api";
import {
  FlightSearchActions,
  FlightShopActions,
  type FlightState,
} from "@b2bportal/core-flights";
import { IdEnum } from "@b2bportal/core-types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api = airRebookApi(axios);

export const fetchRebookFlights = createAsyncThunk<
  ShopResponseResultSuccess & { flights: Flights },
  { contractId: string; route: Route },
  { state: FlightState; rejectValue: { error: string } }
>("flights-rebook/fetchFlights", async ({ contractId, route }, thunkAPI) => {
  try {
    thunkAPI.dispatch(FlightShopActions.setFetchFlightsPending());

    const {
      data: { result },
    } = await api.apiV0AirRebookShopPost({
      method: {
        Method: ShopRequestMethodEnum.DisruptionContract,
        contractId,
        route,
      },
    });

    switch (result.Result) {
      case ResponseEnum.Success: {
        thunkAPI.dispatch(
          FlightSearchActions.setOrigin({
            id: {
              Id: IdEnum.Flight,
              code: route.origin,
            },
            label: result.rebookOrigin.displayName,
            trackingProperties: {},
          })
        );
        thunkAPI.dispatch(
          FlightSearchActions.setDestination({
            id: {
              Id: IdEnum.Flight,
              code: route.destination,
            },
            label: result.rebookDestination.displayName,
            trackingProperties: {},
          })
        );
        thunkAPI.dispatch(
          FlightShopActions.setFetchFlightsSuccess({
            flights: result.flights,
            trackingProperties: {},
          })
        );
        return result;
      }
      case ResponseEnum.Failure: {
        thunkAPI.dispatch(FlightShopActions.setFetchFlightsRejected());
        return thunkAPI.rejectWithValue({ error: result.reason });
      }
      default: {
        thunkAPI.dispatch(FlightShopActions.setFetchFlightsRejected());
        return thunkAPI.rejectWithValue({
          error: `Unmatched response type: ${result["Result"]}`,
        });
      }
    }
  } catch (error) {
    // Reject the thunk with an error message
    thunkAPI.dispatch(FlightShopActions.setFetchFlightsRejected());
    return thunkAPI.rejectWithValue({ error: String(error) });
  }
});
